import { storyblokEditable } from "@storyblok/react/rsc";

// Components
import Block from "@/components/block";
import Container from "@/components/container";
import Grid from "@/components/grid";

export default function Features({ blok }: any) {
  return (
    <section {...storyblokEditable(blok)}>
      <Block>
        <Container className="flex flex-col gap-y-8">
          {blok.title && <h2 className="font-bold text-3xl">{blok.title}</h2>}
          <Grid>
            {blok.features.map((feature: any, index) => (
              <article className="col-span-4 flex flex-col gap-y-2" key={index}>
                <h3 className="font-bold text-xl">
                  {feature.content?.title
                    ? feature.content?.title
                    : feature.name}
                </h3>
                {feature.content?.content && (
                  <p className="text-gray-50 leading-[1.8] font-medium text-base">
                    {feature.content?.content}
                  </p>
                )}
              </article>
            ))}
          </Grid>
        </Container>
      </Block>
    </section>
  );
}
